<template>
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="disabled"
    v-bind="{ ...$attrs, ...$props }"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date_readable"
        readonly
        dense
        :disabled="disabled"
        hide-details
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker no-title v-model="isoDate" @input="inputHandler" />
  </v-menu>
</template>

<script>
import { format, parseISO } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

export default {
  name: 'AdminInputDatepicker',
  props: {
    timestamp: {
      type: String,
      default: Date.now().toString(),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    date_readable() {
      return format(parseISO(this.timestamp), TimeFormats.dateSlashes)
    },
    isoDate: {
      get() {
        return format(parseISO(this.timestamp), TimeFormats.dateDashes)
      },
      set(newDate) {
        this.$emit('input', newDate)
      },
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    inputHandler(val) {
      this.$emit('input', val)
      this.show = false
    }, // inputHandler
  },
}
</script>
